import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const errors = [
	{
		errorCode: 'invalid_link',
		title: 'Invalid Link',
		errorMessage:
			'The link you are trying to access is invalid. Please contact your administrator to send you a new request.',
	},
	{
		errorCode: 'expired_link',
		title: 'Your access link has expired',
		errorMessage:
			'The URL you have provided has expired and is not accessible anymore. Please contact your administrator to send you a new request.',
	},
	{
		errorCode: 'invalid_account',
		title: 'Invalid Link',
		errorMessage:
			'The link you are trying to access is invalid. Please contact your administrator to send you a new request.',
	},
	{
		errorCode: 'generic_error',
		title: 'Something went wrong....',
		errorMessage:
			'Something went wrong while we were processing your request. Please try again.',
	},
	{
		errorCode: 'account_mismatch',
		title: 'Account Authentication Mismatch',
		errorMessage:
			`You are logged in with a user linked to a different tenant than the one you are trying to access. 
			Please log out and use the link provided in the email.`,
	},

];

const ErrorHandling = (props) => {
	const history = useHistory();
	const [errorLog, setErrorLog] = React.useState('');
	const [errorTitle, setErrorTitle] = React.useState('');

	useEffect(() => {
		const params = new URLSearchParams(history.location.search);
		const errorCode = params.get('code') ?? '';
		let error = errors.find(error => error.errorCode === errorCode);
		if (!error) error = errors.find(error => error.errorCode === 'generic_error');
		setErrorLog(error.errorMessage);
		setErrorTitle(error.title);
	}, [history.location.search]);

	return (
		<>
			<Typography style={{ marginBottom: 20, textAlign: 'center', fontSize: '20px' }} variant='body1' color='primary'>
				{errorTitle}
			</Typography>
			<Typography style={{ marginBottom: 20, textAlign: 'center', whiteSpace: 'pre', fontSize: '16px' }} variant='body2' color='error'>
				{errorLog}
			</Typography>
		</>
	);
};

export default ErrorHandling;
